import { StorageLocationSchema } from "@redotech/redo-fulfillment-wms-common/schema/storage-location";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const PrefixGroupChildSchema = z.object({
  storageLocation: StorageLocationSchema,
  productCount: z.number().int().nonnegative(),
  unitCount: z.number().int().nonnegative(),
});

export const getStorageLocationPrefixGroup = {
  name: "getStorageLocationPrefixGroup" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    storageLocationId: storageLocationIdFormat.schema,
  }),
  output: z.object({
    starter: z
      .object({
        productCount: z.number().int().nonnegative(),
        unitCount: z.number().int().nonnegative(),
      })
      .nullable(),
    children: z.array(PrefixGroupChildSchema),
  }),
};
